import { render, staticRenderFns } from "./SelectMajor.vue?vue&type=template&id=837361fe&scoped=true"
import script from "./SelectMajor.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectMajor.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837361fe",
  null
  
)

export default component.exports